module.exports = __webpack_public_path__ + "media/images/game/pages/logo_your_chance-de64b13aae08a2c3ea74321147476c23.png";